import makeStyles from "@mui/styles/makeStyles";

export const useMailEditorStyles = makeStyles((theme) => ({
  brick: {
    position: 'relative',
    borderLeft: '4px solid transparent',
    cursor: 'pointer',
    border: '1px solid transparent',
    "&:hover": {
      borderLeft: '4px solid #808080',
      border: '1px dashed #808080',
      "& $brickControls": {
        display: 'block', // Show controls on hover
      }
    }
  },
  brickWithActivation: {
    position: 'relative',
    cursor: 'pointer',
    border: '1px solid transparent',
    "&:hover": {
      border: '1px dashed #808080',
      "& $brickControls": {
        display: 'block', // Show controls on hover
      }
    }
  },
  activationIndicator: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    width: '12px',
    borderRadius: '10px',
    zIndex: 1,
  },
  editorDialog: {
    minHeight: '400px'
  },
  brickControls: {
    display: 'none', // Hidden by default
    position: 'absolute',
    left: '-2px',
    top: '0',
    zIndex: 100,
    backgroundColor: (theme as any).palette.primary.main,
    padding: '1px',
    // Remove the border or adjust it to match theme
    borderRadius: '2px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
  },
  controlButton: {
    // Apply contrastText color from theme
    color: 'white !important', // Force white color with !important
    // Remove or adjust border to better match theme
    border: 'none',
    marginBottom: '5px',
    "& svg": {
      fill: 'white', // Directly style the SVG icons
      color: 'white !important' // Add !important to override any other styles
    },
    "&:hover": {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    }
  },
  container: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    marginBottom: '10px',
    cursor: 'pointer',
    backgroundColor: '#f0f0f0',
    padding: '10px'
  },
  header: {
    padding: '10px'
  },
  from: {
    display: 'flex',
    flexDirection: 'row',
    padding: '10px'
  },
  item: {
    marginRight: '10px'
  }
}));